import { defineNuxtPlugin, useABTestStore } from "#imports";
export default defineNuxtPlugin({
  name: "global-abtest-plugin",
  parallel: true,
  dependsOn: ["backend-api-cookies", "logger"],
  async setup() {
    const { fetchCampaignsVariations } = useABTestStore();
    await fetchCampaignsVariations();
  }
});
